import { Graphics } from 'pixi.js';

// Render the nova-bomb expanding shockwave ring. Pure stateless drawing —
// caller passes the current x/y/r/t (timer counted down each frame in main.ts)
// and this paints the 5-layer gradient ring (warm halo + bright leading edge +
// inner cyan air-shock). Snaps to full radius in first 25% of timer then fades.
export function drawNovaRing(g: Graphics, x: number, y: number, R: number, t: number): void {
  g.clear();
  if (t <= 0) return;
  const totalDur = 0.85;
  const f = 1 - t / totalDur;
  const expand = f < 0.25 ? f / 0.25 : 1;
  const r = R * (0.05 + 0.95 * expand);
  const fade = f < 0.25 ? 1 : 1 - (f - 0.25) / 0.75;
  // Outer thick warm halo
  g.circle(x, y, r * 1.06);
  g.stroke({ width: 14, color: 0xff6622, alpha: 0.45 * fade });
  g.circle(x, y, r);
  g.stroke({ width: 8, color: 0xffaa44, alpha: 0.75 * fade });
  // Bright white-hot leading edge
  g.circle(x, y, r);
  g.stroke({ width: 4, color: 0xffffff, alpha: 0.95 * fade });
  // Trailing inner cyan-edged ring (post-flash air shock)
  g.circle(x, y, r * 0.84);
  g.stroke({ width: 2.5, color: 0x88ccff, alpha: 0.6 * fade });
  g.circle(x, y, r * 0.66);
  g.stroke({ width: 1.5, color: 0xffaa44, alpha: 0.4 * fade });
}
